import { Drawer } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import HeaderTitle from '../../common/HeaderTitle';
import { getSpecificationDetailBpo, getSpecificationDetailTco } from '../actions/Costing';
import { QuotationId } from '../../rfq/ViewRfq';
import LoaderCustom from '../../common/LoaderCustom';
import { TextFieldHookForm } from '../../layout/HookFormInputs';
import { Controller, useForm } from 'react-hook-form';
import NoContentFound from '../../common/NoContentFound';
import { EMPTY_DATA, TOOLING } from '../../../config/constants';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import SOPListing from './SOPListing';
import _ from 'lodash';
import DayTime from '../../common/DayTimeWrapper';

const PartSpecificationDrawer = (props) => {
    const gridOptions = {};
    const { register, control, formState: { errors } } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
    });
    const [isLoader, setIsLoader] = useState(false);
    const quotationId = useSelector((state) => state.rfq.quotationIDForRFQ ?? '');
    const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const dispatch = useDispatch();
    const { partSpecificationRFQData } = useSelector((state) => state?.costing);
    const [gridsApi, setGridsApi] = useState({
        firstGrid: { api: null, columnApi: null },
        secondGrid: { api: null, columnApi: null },
    });

    const toggleDrawer = (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        props.closeDrawer('');
    };
    const { baseCostingId, bopId, bopQuotationId } = props
    useEffect(() => {
        setIsLoader(true);
        if (baseCostingId?.length > 0) {
            dispatch(getSpecificationDetailTco(quotationId, baseCostingId, (res) => {

                let Data = res?.data?.Data
                if (Data?.SpecsHead && Data?.SpecsColumn) {

                    setColumnDefs(generateColumnDefs(Data?.SpecsHead));
                    setRowData(Data?.SpecsColumn); // Directly use SpecsColumn as row data
                }
                setIsLoader(false);
            }));
        }
        else if (bopId?.length > 0) {
            setIsLoader(true);
            dispatch(getSpecificationDetailBpo(bopQuotationId, bopId, (res) => {
                let Data = res?.data?.Data
                if (Data?.SpecsHead && Data?.SpecsColumn) {
                    setColumnDefs(generateColumnDefs(Data?.SpecsHead));
                    setRowData(Data?.SpecsColumn); // Directly use SpecsColumn as row data
                }
                setIsLoader(false);
            }));
        }

        else {
            setIsLoader(false);
        }

    }, [quotationId, baseCostingId, dispatch]);

    const generateColumnDefs = (specsHead) => {
        return specsHead.map((head, index) => ({
            headerName: head,
            field: head, // Use the head value directly as the field name
            sortable: true,
            filter: true,
            cellRenderer: index >= 2 ? 'vendorDataRenderer' : undefined,

        }));
    };
    const VendorDataRenderer = (props) => {
        const specValueField = 'Part Specs Value'; // The field name for the specification value
        const vendorValue = props.value;
        const specValue = props.data[specValueField];
        const isChanged = vendorValue !== specValue && vendorValue !== null && vendorValue !== undefined && vendorValue !== '';

        return (
            <span style={{ color: isChanged ? 'red' : 'inherit' }}>
                {vendorValue !== null && vendorValue !== undefined ? vendorValue : '-'}
            </span>
        );
    };

    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        floatingFilter: true,
    };

    const onGridReady = (params, gridIdentifier) => {
        setGridsApi(prev => ({
            ...prev,
            [gridIdentifier]: { api: params.api, columnApi: params.columnApi },
        }));

        params.api.paginationGoToPage(0);
        params.api.sizeColumnsToFit();
    };

    const frameworkComponents = {
        customLoadingOverlay: LoaderCustom,
        customNoRowsOverlay: NoContentFound,
        vendorDataRenderer: VendorDataRenderer,

    };

    return (

        <Drawer className="top-drawer" anchor={"right"} open={props?.isOpen} onClose={toggleDrawer}>
            <Container>

                <div className="drawer-wrapper layout-min-width-720px">
                    <Row className="drawer-heading">
                        <Col>
                            <div className="header-wrapper left">
                                <h3>{`${props.type === 'BOP' ? 'BOP' : 'TCO'} Specification Detail`}</h3>
                            </div>
                            <div onClick={toggleDrawer} className="close-button right"></div>
                        </Col>
                    </Row>
                    {isLoader ?
                        <LoaderCustom customClass="loader-center" /> :
                        <>
                            <Col md="12">
                                <HeaderTitle title="Specifications" customClass="mt-3" />
                                {rowData?.length > 0 && (
                                    <Row className="mt-1 part-detail-wrapper">
                                        {props.type !== 'BOP' && props.partType !== 'Tooling' && (<Col md="3">
                                            <TextFieldHookForm
                                                label="Havells Design Part"
                                                name="HavellsDesignPart"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                disabled={true}
                                                defaultValue={partSpecificationRFQData?.HavellsDesignPart || ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Specification}
                                            />
                                        </Col>)}
                                        {props.type !== 'BOP' && props.partType !== 'Tooling' && (<Col md="3">
                                            <TextFieldHookForm
                                                label="Target Price"
                                                name="TargetPrice"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                defaultValue={partSpecificationRFQData?.TargetPrice || ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Description}
                                                disabled={true}
                                                placeholder="-"
                                            />
                                        </Col>)}
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label="UOM"
                                                name="UOMSymbol"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                defaultValue={partSpecificationRFQData?.UOMSymbol || ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Description}
                                                disabled={true}
                                                placeholder="-"
                                            />
                                        </Col>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                label="Date"
                                                name="TimeLine"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                defaultValue={partSpecificationRFQData?.TimeLine ? DayTime(partSpecificationRFQData?.TimeLine).format('DD/MM/YYYY') : ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Description}
                                                disabled={true}
                                                placeholder="-"
                                            />
                                        </Col>
                                        {props.type !== 'BOP' && (<Col md="3">
                                            <TextFieldHookForm
                                                label={props?.partType === 'Tooling' ? "Tool Number" : "Part Number"}
                                                name="PartNumber"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                defaultValue={partSpecificationRFQData?.SOPQuantityDetails[0]?.PartNumber || ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Description}
                                                disabled={true}
                                                placeholder="-"
                                            />
                                        </Col>)}
                                        {props?.partType === TOOLING && (<Col md="3">
                                            <TextFieldHookForm
                                                label={"Tool Life"}
                                                name="toolLife"
                                                Controller={Controller}
                                                control={control}
                                                register={register}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                defaultValue={partSpecificationRFQData?.AdditionalDetailsForPart
                                                    ?.ToolLife
                                                    || ""}
                                                className=""
                                                customClassName="withBorder"
                                                errors={errors.Description}
                                                disabled={true}
                                                placeholder="-"
                                            />
                                        </Col>)}
                                    </Row>
                                )}
                                <div className="ag-grid-react">
                                    <div className={`ag-grid-wrapper height-width-wrapper ${rowData?.length <= 0 ? "overlay-contain" : ""}`}>
                                        <div className="ag-theme-material">
                                            <AgGridReact
                                                defaultColDef={defaultColDef}
                                                floatingFilter={true}
                                                domLayout="autoHeight"
                                                gridOptions={gridOptions}
                                                columnDefs={columnDefs}
                                                rowData={rowData}
                                                onGridReady={(e) => onGridReady(e, "firstGrid")}
                                                loadingOverlayComponent="customLoadingOverlay"
                                                noRowsOverlayComponent="customNoRowsOverlay"
                                                noRowsOverlayComponentParams={{
                                                    title: EMPTY_DATA,
                                                    imagClass: 'imagClass'
                                                }}
                                                frameworkComponents={frameworkComponents}
                                                suppressRowClickSelection={true}
                                                rowSelection="multiple"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <div className="ag-theme-material mt-3" >
                                <div className={`ag-grid-wrapper height-width-wrapper ${partSpecificationRFQData?.SOPQuantityDetails?.length <= 0 ? "overlay-contain" : ""}`}>

                                    {partSpecificationRFQData?.SOPQuantityDetails && partSpecificationRFQData?.SOPQuantityDetails?.length > 0 ? (
                                        <AgGridReact
                                            defaultColDef={defaultColDef}
                                            domLayout="autoHeight"
                                            frameworkComponents={frameworkComponents}
                                            suppressRowClickSelection={true}
                                            rowSelection="multiple"
                                            rowData={partSpecificationRFQData?.SOPQuantityDetails}
                                            onGridReady={(e) => onGridReady(e, "secondGrid")}
                                            noRowsOverlayComponentParams={{
                                                title: EMPTY_DATA,
                                                imagClass: 'imagClass'
                                            }}
                                        >
                                            <AgGridColumn width={"230px"} field="YearName" headerName="Production Year"></AgGridColumn>
                                            <AgGridColumn width={"230px"} field="Quantity" headerName="Annual Forecast Quantity" colId="Quantity"></AgGridColumn>
                                            {/* Additional columns can be added here */}
                                        </AgGridReact>
                                    ) : null}
                                </div>
                            </div>
                        </>
                    }

                </div>
            </Container>
        </Drawer>

    );
};

export default PartSpecificationDrawer;
